/**
 * THE COVER'S SHAPE, IN ONE PLACE.
 *
 * A group cover is cropped once and then drawn in at least three places: the
 * cropper's own viewport, the two previews in "Opret gruppe", and the band at
 * the top of the group. Each of those used to name the shape itself — the
 * cropper as a number, the band as a Tailwind class, the previews as a fixed
 * pixel height — and they drifted, which is OSO-626: the previews were `h-36`
 * and `h-28`, so the picture the user had just cropped to 3:1 was cropped AGAIN
 * by `object-cover`, at whatever ratio the column happened to give. The two
 * previews did not even agree with each other.
 *
 * Nothing about that fails: every one of those renders perfectly. So the fix is
 * not to correct the numbers but to remove the second copy of them — the
 * cropper and every frame now take the shape from here.
 *
 * A TAILWIND CLASS CANNOT BE BUILT FROM A NUMBER. The scanner only sees class
 * names it can read as literal text, so `aspect-[${n}/1]` would compile and
 * then produce no CSS at all. Hence the pair, and the test in
 * `lib/__tests__/coverAspect.test.ts` that holds them to the same value.
 */

/** Width ÷ height. What `ImageCropper` takes as `aspect`. */
export const COVER_ASPECT = 3;

/** The same ratio as a frame. Must stay in step with `COVER_ASPECT`. */
export const COVER_ASPECT_CLASS = "aspect-[3/1]";
